import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing the security changes view.
 * @extends JetView
 */
export default class securityChangesView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The layout configuration.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager',
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
            ],
        };
        const left = {
            rows: [
                {
                    view: 'toolbar',
                    css: theme,
                    elements: [
                        { view: 'label', label: _('QR') }, // QR label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                {
                    view: 'template',
                    id: 'templateQR',
                    onClick: {
                        copy_text: function (ev, id) {
                            var copyText = document.getElementById('lname'); // Get input element
                            copyText.select(); // Select input text
                            copyText.setSelectionRange(0, 99999); // Set selection range
                            document.execCommand('copy'); // Copy to clipboard
                            webix.message(_('QR Copiado!')); // Show message on copy
                        },
                    },
                },
                {
                    view: 'label',
                    label: _(
                        'No tienes un QR Configurado, por favor comunicarse con soporte.', // Error message if no QR is configured
                    ),
                    localId: 'label',
                    id: 'labelError', // ID for error label
                },
            ],
        };
        return {
            type: 'wide',
            cols: [left], // Main layout structure
        };
    }

    /**
     * Initializes the view and fetches QR data.
     */
    init() {
        const cur_user = this.getParam('user', true); // Get current user parameter
        $$('labelError').hide(); // Hide error label initially
        webix.ajax().get(devConfig.geturlApi() + 'Client/GetMyQRGoogle', '', {
            error: function (text, data, XmlHttpRequest) {
                webix.message('Error! '); // Show error message on AJAX error
            },
            success: function (text, data, XmlHttpRequest) {
                var text = JSON.parse(text); // Parse response text
                var input = '1234'; // Placeholder input value
                if (!text.HasError) {
                    // Check for errors in response
                    $$('templateQR').show(); // Show QR template
                    $$('labelError').hide(); // Hide error label
                    $$('templateQR').setHTML(
                        `<div style="text-align: center;">
                          <img style="display:inline-block" src="` +
                            text.data +
                            `"> // Display QR image
                       </div>
                       <br>
                       <div style="text-align: center;">
                          <input type="text" id="lname" name="lname"
                              style="width: 50%;
                              padding: 12px 20px;
                              margin: 8px 0;
                              display: inline-block;
                              border: 1px solid #ccc;
                              border-radius: 4px;
                              box-sizing: border-box;
                              text-align: center;"
                              value="` +
                            text.text +
                            `"> // Input field for QR text
                          <button class='button-login copy_text'
                            style="
                            background-color: #263043 !important;
                            color: white;
                            padding: 14px 20px;
                            margin: 8px 0;
                            border: none;
                            border-radius: 4px;
                            cursor: pointer;"><span class="icon-copy"></span></button>
                       </div>
                      `,
                    );
                } else {
                    $$('templateQR').hide(); // Hide QR template on error
                    $$('labelError').show(); // Show error label
                }
            },
        });
    }
}

// FILE DOCUMENTED
